var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteLeftinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 150,
    viewBox: "0 0 220 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M94.624 100.806c0-11.29-3.417-20.967-10.251-29.032-6.834-8.602-15.508-14.247-26.022-16.935 1.052-6.99 3.68-14.248 7.886-21.774C70.967 25 75.962 18.548 81.219 13.71L65.448 0C21.816 29.57 0 63.172 0 100.806c0 13.979 4.468 25.807 13.405 35.484C22.867 145.43 34.17 150 47.312 150c13.142 0 24.181-4.839 33.118-14.516 9.462-9.678 14.194-21.237 14.194-34.678zm125.376 0c0-11.29-3.417-20.967-10.251-29.032-6.834-8.602-15.508-14.247-26.021-16.935 1.577-7.527 4.468-15.054 8.673-22.58 4.732-7.528 9.726-13.71 14.983-18.55L190.824 0c-44.157 30.645-66.236 64.247-66.236 100.806 0 13.441 4.731 25 14.193 34.678 9.463 9.677 20.765 14.516 33.907 14.516 12.617 0 23.656-4.839 33.118-14.516 9.463-9.678 14.194-21.237 14.194-34.678z",
    fill: "#5945FF"
  })));
}

export default SvgQuoteLeftinline;